import { defineContent, type DefinedContent } from '@post-office/define-content';

export const registeredContent: DefinedContent<
	[
		'header',
		'body',
		'cta',
		'close',
		'imageAlt',
		'whyAmISeeingThisTitle',
		'whyAmISeeingThisMessage',
		'whyAmISeeingThisReasonActions',
		'whyAmISeeingThisReasonSuggestions',
	]
> = defineContent({
	default: {
		header: {
			id: 'post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.header',
			defaultMessage: 'Automate meeting notes',
			description: 'Header text for confluence side nav next best action banner',
			role: 'title',
		},
		body: {
			id: 'post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.body',
			defaultMessage:
				'Instead of manually typing meeting notes, why not try Loom to record meetings?',
			description: 'Body for confluence side nav next best action banner',
			role: 'description',
		},
		cta: {
			id: 'post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.cta',
			defaultMessage: 'Try now',
			description: 'Call to action text for confluence side nav next best action banner',
		},
		close: {
			id: 'post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.close',
			defaultMessage: 'Close',
			description: 'Label for the close icon that is represented by an X',
		},
		imageAlt: {
			id: 'post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.image-alt',
			defaultMessage: 'Notepad with sparkling background',
			description: 'Alternate text for picture of notepad with sparkles behind it',
		},
		whyAmISeeingThisTitle: {
			id: 'post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.ad-controls.why-am-i-seeing-this',
			defaultMessage: 'Why am I seeing this?',
			description: 'the title to the modal',
		},
		whyAmISeeingThisMessage: {
			id: 'post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.ad-controls.recommendation-basis',
			defaultMessage: 'This recommendation is based on:',
			description: 'the main message of the modal',
		},
		whyAmISeeingThisReasonActions: {
			id: 'post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.ad-controls.actions-done-so-far',
			defaultMessage: 'What you\u2019ve done so far in the product',
			description:
				'the first reason for displaying the message to the customer: what actions the customer has actioned so far in the product',
		},
		whyAmISeeingThisReasonSuggestions: {
			id: 'post-office.confluence-side-nav.next-best-action.1-on-1-loom-nudge.ad-controls.suggestions',
			defaultMessage: 'What we suggest to help you get the most value from Atlassian',
			description:
				'the second reason for displaying the message to the customer: what we suggest to help the customer',
		},
	},
});
